import React from 'react';

export class Kicked extends React.Component {

    render() {
        return <div className="error">
            tu t'es fait kicker boloss
        </div>
    }

}